import InlinePageHeading from './InlinePageHeading';
import InlinePageSectionHeading from './InlinePageSectionHeading';
import InlinePageText from './InlinePageText';
import InlinePageTextArea from './InlinePageTextArea';
import InlinePageDesignRow from './InlinePageDesignRow';
import InlinePageRanges from './InlinePageRanges';
import InlinePageImageRow from './InlinePageImageRow';
import InlinePageFileDeliverables from './InlinePageFileDeliverables';

import createInlinePages from './createInlinePages';

export { default } from './InlinePage';
export * from './InlinePage';

export const FIELD = {
    InlinePageHeading,
    InlinePageSectionHeading,
    InlinePageText,
    InlinePageTextArea,
    InlinePageDesignRow,
    InlinePageRanges,
    InlinePageImageRow,
    InlinePageFileDeliverables,
};

export { createInlinePages };
